export default new Promise(resolve => (
	(window.utahHeader && window.utahHeader.isLoaded) ?
		resolve() :
		window.addEventListener('ugovHeaderLoaded', resolve))
);
